export const initialNursingRecord = {
  nanda: {
    domain: '',
    class: '',
    diagnosis: '',
    collectingData: '',
    goal: '',
    plan: '',
    interventions: '',
    evaluation: '',
  },
  soapie: {
    subjective: '',
    objective: '',
    assessment: '',
    planning: '',
    interventions: '',
    evaluation: '',
  },
  focusDar: { focus: '', data: '', action: '', response: '' },
  narrativeRecord: { narrativeNote: '' },
  remarks: {
    assessment: '',
    diagnosisRelate: '',
    diagnosis: '',
    goal: '',
    plan: '',
    interventions: '',
    evaluation: '',
  },
  remarks_two: {},
  omaha: {
    domain: '',
    problem: '',
    modifier1: '',
    modifier2: '',
    priority: '',

    sign_sx: '',
    sign_sx_etc: '',
    omaha_target1: '',
    omaha_target2: '',
    omaha_target3: '',
    omaha_target4: '',

    omaha_knowledge_selct: '',
    omaha_knowledge: '',
    omaha_behavior_selct: '',
    omaha_behavior: '',
    omaha_status_selct: '',
    omaha_status: '',
  },
  icnp: {},
  icnp_browser: {},
};

export const initialECardex = {
  update_at: '',
  other_remarks: '',
  remark_data: [],
  medication_data: [],
  lab_data: [],
  imaging_test_data: [],
  concerns: '',
  plans: '',
  evaluation: '',
};

export const initialTakingOver = {
  update_at: '',
  loc: '',
  vital_sign: '',
  current_condition: '',
  rbfi: '',
  reasons: '',
  intervention: '',
  other: '',
};

export const initialSBAR = {
  update_at: '',
  situation: '',
  background: '',
  assessment: '',
  recommendation: '',
};

export const initialSBAR2 = {
  update_at: '',

  situation1: {
    checked1: false,
  },
  situation1_input1: '',
  situation2: {
    checked1: false,
  },
  situation2_input: '',

  background_infection: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  background_allergy: {
    checked1: false,
    checked2: false,
  },
  background_allergy_input1: '',
  background_allergy_input2: '',
  background_input: '',

  assessment: {
    checked1: false,
  },
  assessment_input1: '',

  recommendation1_input1: '',
  recommendation1: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  recommendation2_monitor_o2: {
    checked1: false,
    checked2: false,
  },
  recommendation2_monitor_o2_input: '',
  recommendation2_monitor_patients: {
    checked1: false,
    checked2: false,
  },
  recommendation2_monitor_etc_input: '',
  recommendation2_etc_input: '',

  sending: '',
  subject: '',
  takeover: '',
  consignee: '',
};

export const initialSBAR3 = {
  update_at: '',

  situation_input: '',

  background_pmh: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
    checked13: false,
    checked14: false,
    checked15: false,
    checked16: false,
    checked17: false,
    checked18: false,
    checked19: false,
  },
  background_tests: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
  },
  background_tests_input: '',

  assessment_contact: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  assessment_need: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  assessment_extras: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  assessment_iv_input: '',
  assessment_iv_date: '',
  assessment_iv_rs: {
    checked1: false,
    checked2: false,
  },
  assessment_iv_site: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  assessment_iv_site_input: '',
  assessment_iv_central: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },

  assessment_drips_ivf: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
  },
  assessment_drips_ivf_input: '',
  assessment_drips_iv_input: '',
  assessment_drips_iv_date: '',
  assessment_drips_drips: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  assessment_neuro: {
    checked1: false,
    checked2: false,
  },
  assessment_neuro_input: '',
  assessment_neuro_activity: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
  },

  assessment_pain_input1: '',
  assessment_pain_input2: '',
  assessment_pain_input3: '',
  assessment_pain_input4: '',

  assessment_res: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  assessment_res_input: '',
  assessment_res_input_trach: '',
  assessment_res_input_sound: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  assessment_res_input_treat: {
    checked1: false,
    checked2: false,
    checked3: false,
  },
  assessment_res_input_cough: {
    checked1: false,
    checked2: false,
  },

  assessment_vs_hr: '',
  assessment_vs_temp: '',
  assessment_vs_bp: '',
  assessment_vs_rr: '',
  assessment_vs_o2: '',

  assessment_cardio: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
  },
  assessment_cardio_edema: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
    checked13: false,
  },
  assessment_cardio_pulse: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  assessment_vte: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
  },
  assessment_gastro_diet: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
  },
  assessment_gastro_symptom: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  assessment_gastro_tube: {
    checked1: false,
    checked2: false,
    checked3: false,
  },
  assessment_genitour: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
    checked13: false,
  },
  assessment_genitour_dialysis: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
  },
  assessment_muscul_weak: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  assessment_muscul_nuber: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  assessment_skin_input: '',
  assessment_bg: {
    checked1: false,
    checked2: false,
    checked3: false,
  },
  assessment_bg_input: '',
  assessment_bg_ac_b: '',
  assessment_bg_ac_l: '',
  assessment_bg_ac_d: '',
  assessment_bg_hs: '',

  assessment_drains: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
  },
  assessment_drains_input: '',
  assessment_lap_0: '',
  assessment_lap_1: '',
  assessment_lap_2: '',
  assessment_lap_3: '',
  assessment_lap_4: '',
  assessment_lap_5: '',
  assessment_lap_6: '',
  assessment_lap_7: '',
  assessment_lap_8: '',
  assessment_lap_9: '',
  assessment_lap_10: '',
  assessment_lap_11: '',
  assessment_lap_12: '',
  assessment_lap_13: '',

  recommendation_schedule: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  recommendation_consults: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
  },
  recommendation_discharge: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
};

export const initialHospitalizationSurvey = {
  offer: '',
  update_at: '',

  contact1: [{ contact: '', name: '', relation: '', etc: '' }],
  contact2: [{ contact: '', name: '', relation: '', etc: '' }],
  contact3: [{ contact: '', name: '', relation: '', etc: '' }],

  default_info: {
    BT: '',
    DBP: '',
    PR: '',
    RR: '',
    SBP: '',
    Sp02: '',
    date: '',
    height: '',
    hospitalization_path: { value: 3, input: '' },
    hospitalization_reason: '',
    hospitalization_way: 4,
    joo_ho_so: '',
    status: 4,
    status02: 4,
    weight: '',
  },
  disease_history: {
    history: { value: 3, checked: [], input: '' },
    family_history: { value: 3, input: '' },
    allergy: { value: 3, input: '' },
    food_allergy: { value: 3, input: '' },
    latest_medicine: { value: 3, input: '' },
    medicine_allergy: { value: 3, input: '' },
    operation_history: { value: 3, input: '' },
  },
  body_status: {
    breath: { value: 3, checked: [], input: '' },
    camouflage: { value: 3, checked: [], input: '' },
    cycle: { value: 3, checked: [], input: '' },
    fain: { checked: [] },
    fall: { checked: [] },
    medicine_history: { value: 3, input: '' },
    nerve: { value: 3, checked: [], input: '' },
    operation_history: { value: 3, input: '' },
    skin: { value: 3, checked: [], input: '' },
    yukchang: { checked: [] },
  },
  habit: {
    drink: { value: 3, checked: [], input: '', input2: '' },
    feces: { value: '', input: '' },
    feces_info: { checked: [] },
    nutrition: { weight: 3, appetite: 3 },
    obstetric: { G: '', T: '', P: '', A: '', L: '' },
    sleep: 3,
    smoke: { value: 3, checked: [], input: '', input2: '' },
    urine: { value: '', input: '' },
    urine_info: { checked: [] },
  },
  functional_evaluation: {
    sit: 4,
    stand_up: 4,
    walk: 4,
    wheel_chair: 4,
  },
  social_history: {
    job: '',
    language: '한국어',
    marry: 3,
    religion: { value: 3, input: '' },
  },
  economy_history: {
    counseling: 3,
    mind_status: { checked: [] },
  },
  education: {
    education_contents: { checked: [], input: '' },
    education_way: 5,
  },
  out_hospital_plan: {
    destination: { value: 4, input: '' },
    guardian: { value: 5, input: '' },
    life: 7,
  },
};

export const initialOutHospitalSurvey = {
  date: '',
  update_at: '',
  default_info: {
    destination: { value: 5, input: '' },
    out_hospital_way: { value: 5, input: '' },
    guardians: { value: 7, input: '' },
    food: { value: 3, input: '' },
    shower: { value: 3, input: '' },
    activity: 3,
  },
  out_hospital_medicines: [
    { amount: '', count: '', days: '', how_to: '', name: '' },
    { amount: '', count: '', days: '', how_to: '', name: '' },
    { amount: '', count: '', days: '', how_to: '', name: '' },
    { amount: '', count: '', days: '', how_to: '', name: '' },
    { amount: '', count: '', days: '', how_to: '', name: '' },
  ],
  out_patients: [
    { call_number: '', date: '', department: '', doctor: '', location: '' },
    { call_number: '', date: '', department: '', doctor: '', location: '' },
  ],
  check_reservations: [
    { call_number: '', date: '', destination: '', name: '', warning: '' },
    { call_number: '', date: '', destination: '', name: '', warning: '' },
  ],
  education: '',
};

export const initialMedicationSurvey = {
  update_at: '',
  medication_surveys: [],
};

export const initialRadiology = {
  radiologies: [],
};

export const initialPathology = {
  pathologies: [],
};

export const initialEtcRecord = {
  miscellaneous: [],
};

export const initialClinicalObservation = {
  update_at: '',
  survey_uuid: '',
  vital_sign: [],
};

export const initialClinicalObservationICU = {
  update_at: '',
  vital_sign: {
    vital00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
      no04: '',
      no05: '',
      no06: '',
      no07: '',
      no08: '',
      no09: '',
    },
    vital01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
      no14: '',
      no15: '',
      no16: '',
      no17: '',
      no18: '',
      no19: '',
    },
    vital02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
      no24: '',
      no25: '',
      no26: '',
      no27: '',
      no28: '',
      no29: '',
    },
    vital03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
      no34: '',
      no35: '',
      no36: '',
      no37: '',
      no38: '',
      no39: '',
    },
    vital04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
      no44: '',
      no45: '',
      no46: '',
      no47: '',
      no48: '',
      no49: '',
    },
    vital05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
      no54: '',
      no55: '',
      no56: '',
      no57: '',
      no58: '',
      no59: '',
    },
    vital06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
      no64: '',
      no65: '',
      no66: '',
      no67: '',
      no68: '',
      no69: '',
    },
    vital07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
      no74: '',
      no75: '',
      no76: '',
      no77: '',
      no78: '',
      no79: '',
    },
    vital08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
      no84: '',
      no85: '',
      no86: '',
      no87: '',
      no88: '',
      no89: '',
    },
    vital09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
      no94: '',
      no95: '',
      no96: '',
      no97: '',
      no98: '',
      no99: '',
    },
  },
  news: {
    news00: '',
    news01: '',
    news02: '',
    news03: '',
    news04: '',
    news05: '',
    news06: '',
    news07: '',
    news08: '',
    news09: '',
  },
  weight_height: {
    weight_height00: {
      no00: '',
      no01: '',
    },
    weight_height01: {
      no10: '',
      no11: '',
    },
    weight_height02: {
      no20: '',
      no21: '',
    },
    weight_height03: {
      no30: '',
      no31: '',
    },
    weight_height04: {
      no40: '',
      no41: '',
    },
    weight_height05: {
      no50: '',
      no51: '',
    },
    weight_height06: {
      no60: '',
      no61: '',
    },
    weight_height07: {
      no70: '',
      no71: '',
    },
    weight_height08: {
      no80: '',
      no81: '',
    },
    weight_height09: {
      no90: '',
      no91: '',
    },
  },
  intake: {
    intake00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
    },
    intake01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
    },
    intake02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
    },
    intake03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
    },
    intake04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
    },
    intake05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
    },
    intake06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
    },
    intake07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
    },
    intake08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
    },
    intake09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
    },
  },
  output: {
    output00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
      no04: '',
    },
    output01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
      no14: '',
    },
    output02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
      no24: '',
    },
    output03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
      no34: '',
    },
    output04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
      no44: '',
    },
    output05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
      no54: '',
    },
    output06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
      no64: '',
    },
    output07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
      no74: '',
    },
    output08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
      no84: '',
    },
    output09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
      no94: '',
    },
  },
  position_change: {
    position_change00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
    },
    position_change01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
    },
    position_change02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
    },
    position_change03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
    },
    position_change04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
    },
    position_change05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
    },
    position_change06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
    },
    position_change07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
    },
    position_change08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
    },
    position_change09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
    },
  },
  restraint: {
    restraint00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
      no04: '',
      no05: '',
      no06: '',
      no07: '',
      no08: '',
    },
    restraint01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
      no14: '',
      no15: '',
      no16: '',
      no17: '',
      no18: '',
    },
    restraint02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
      no24: '',
      no25: '',
      no26: '',
      no27: '',
      no28: '',
    },
    restraint03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
      no34: '',
      no35: '',
      no36: '',
      no37: '',
      no38: '',
    },
    restraint04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
      no44: '',
      no45: '',
      no46: '',
      no47: '',
      no48: '',
    },
    restraint05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
      no54: '',
      no55: '',
      no56: '',
      no57: '',
      no58: '',
    },
    restraint06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
      no64: '',
      no65: '',
      no66: '',
      no67: '',
      no68: '',
    },
    restraint07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
      no74: '',
      no75: '',
      no76: '',
      no77: '',
      no78: '',
    },
    restraint08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
      no84: '',
      no85: '',
      no86: '',
      no87: '',
      no88: '',
    },
    restraint09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
      no94: '',
      no95: '',
      no96: '',
      no97: '',
      no98: '',
    },
  },
  ipc: {
    ipc00: '',
    ipc01: '',
    ipc02: '',
    ipc03: '',
    ipc04: '',
    ipc05: '',
    ipc06: '',
    ipc07: '',
    ipc08: '',
    ipc09: '',
  },
  vent: {
    vent00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
      no04: '',
      no05: '',
      no06: '',
      no07: '',
      no08: '',
      no09: '',
      no010: '',
      no011: '',
    },
    vent01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
      no14: '',
      no15: '',
      no16: '',
      no17: '',
      no18: '',
      no19: '',
      no110: '',
      no111: '',
    },
    vent02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
      no24: '',
      no25: '',
      no26: '',
      no27: '',
      no28: '',
      no29: '',
      no210: '',
      no211: '',
    },
    vent03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
      no34: '',
      no35: '',
      no36: '',
      no37: '',
      no38: '',
      no39: '',
      no310: '',
      no311: '',
    },
    vent04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
      no44: '',
      no45: '',
      no46: '',
      no47: '',
      no48: '',
      no49: '',
      no410: '',
      no411: '',
    },
    vent05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
      no54: '',
      no55: '',
      no56: '',
      no57: '',
      no58: '',
      no59: '',
      no510: '',
      no511: '',
    },
    vent06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
      no64: '',
      no65: '',
      no66: '',
      no67: '',
      no68: '',
      no69: '',
      no610: '',
      no611: '',
    },
    vent07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
      no74: '',
      no75: '',
      no76: '',
      no77: '',
      no78: '',
      no79: '',
      no710: '',
      no711: '',
    },
    vent08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
      no84: '',
      no85: '',
      no86: '',
      no87: '',
      no88: '',
      no89: '',
      no810: '',
      no811: '',
    },
    vent09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
      no94: '',
      no95: '',
      no96: '',
      no97: '',
      no98: '',
      no99: '',
      no910: '',
      no911: '',
    },
  },
  crrt: {
    crrt00: {
      no00: '',
      no01: '',
      no02: '',
      no03: '',
      no04: '',
      no05: '',
      no06: '',
      no07: '',
      no08: '',
      no09: '',
      no010: '',
      no011: '',
      no012: '',
      no013: '',
      no014: '',
    },
    crrt01: {
      no10: '',
      no11: '',
      no12: '',
      no13: '',
      no14: '',
      no15: '',
      no16: '',
      no17: '',
      no18: '',
      no19: '',
      no110: '',
      no111: '',
      no112: '',
      no113: '',
      no114: '',
    },
    crrt02: {
      no20: '',
      no21: '',
      no22: '',
      no23: '',
      no24: '',
      no25: '',
      no26: '',
      no27: '',
      no28: '',
      no29: '',
      no210: '',
      no211: '',
      no212: '',
      no213: '',
      no214: '',
    },
    crrt03: {
      no30: '',
      no31: '',
      no32: '',
      no33: '',
      no34: '',
      no35: '',
      no36: '',
      no37: '',
      no38: '',
      no39: '',
      no310: '',
      no311: '',
      no312: '',
      no313: '',
      no314: '',
    },
    crrt04: {
      no40: '',
      no41: '',
      no42: '',
      no43: '',
      no44: '',
      no45: '',
      no46: '',
      no47: '',
      no48: '',
      no49: '',
      no410: '',
      no411: '',
      no412: '',
      no413: '',
      no414: '',
    },
    crrt05: {
      no50: '',
      no51: '',
      no52: '',
      no53: '',
      no54: '',
      no55: '',
      no56: '',
      no57: '',
      no58: '',
      no59: '',
      no510: '',
      no511: '',
      no512: '',
      no513: '',
      no514: '',
    },
    crrt06: {
      no60: '',
      no61: '',
      no62: '',
      no63: '',
      no64: '',
      no65: '',
      no66: '',
      no67: '',
      no68: '',
      no69: '',
      no610: '',
      no611: '',
      no612: '',
      no613: '',
      no614: '',
    },
    crrt07: {
      no70: '',
      no71: '',
      no72: '',
      no73: '',
      no74: '',
      no75: '',
      no76: '',
      no77: '',
      no78: '',
      no79: '',
      no710: '',
      no711: '',
      no712: '',
      no713: '',
      no714: '',
    },
    crrt08: {
      no80: '',
      no81: '',
      no82: '',
      no83: '',
      no84: '',
      no85: '',
      no86: '',
      no87: '',
      no88: '',
      no89: '',
      no810: '',
      no811: '',
      no812: '',
      no813: '',
      no814: '',
    },
    crrt09: {
      no90: '',
      no91: '',
      no92: '',
      no93: '',
      no94: '',
      no95: '',
      no96: '',
      no97: '',
      no98: '',
      no99: '',
      no910: '',
      no911: '',
      no912: '',
      no913: '',
      no914: '',
    },
  },
};

export const initialGlucose = {
  update_at: '',
  blood_sugar_log: [],
  prescription: [],
};

export const initialIntakeOutput = {
  update_at: '',
  intake_output_survey: [],
};

export const initialNEWS2 = {
  date: '',
  update_at: '',
  respiration: '',
  hypercapnic: '',
  spo2Yes: '',
  spo2No: '',
  roomAir: '',
  temperatur: '',
  systolic: '',
  pulse: '',
  consciousness: '',
};

export const initialBedScore = {
  date: '',
  update_at: '',
  contents: {
    sensoryPerception: '',
    humidity: '',
    activity: '',
    mobility: '',
    nutrition: '',
    frictionAndDissolutionForce: '',
  },
};

export const initialBedScoreTwo = {
  date: '',
  update_at: '',
  contents: {
    sensoryPerception: '',
    humidity: '',
    activity: '',
    mobility: '',
    nutrition: '',
    frictionAndDissolutionForce: '',
  },
};

export const initialBedScoreThree = {
  date: '',
  update_at: '',
  contents: {
    body: '',
    mental: '',
    activity: '',
    mobility: '',
    urinary: '',
  },
};

export const initialBedScoreFour = {
  update_at: '',
  gender: '',
  age: '',
  weight: '',
  incontinence: '',
  mobility: '',
  appetite: '',

  skin00: false,
  skin01: false,
  skin02: false,
  skin03: false,
  skin04: false,
  skin05: false,

  special_risk00: false,
  special_risk01: false,
  special_risk02: false,
  special_risk03: false,
  special_risk04: false,
  special_risk05: false,
  special_risk06: false,
  special_risk07: false,
  special_risk08: false,
  special_risk09: false,
  special_risk010: false,
  special_risk011: false,
  special_risk012: false,
  special_risk013: false,
  special_risk014: false,
};

export const initialNeeds = {
  date: '',
  update_at: '',
  body_status: {
    takeOffClothes: '',
    eat: '',
    sitUp: '',
    toilet: '',
    washFace: '',
    bath: '',
    transfer: '',
    controlStool: '',
    brushTeeth: '',
    changePosition: '',
    getOutRoom: '',
    controlUrine: '',
  },
  disease_status: {
    chronic: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      cancer: '',
    },
    circulatory: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      etc: '',
    },
    nervous: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked5: false,
      etc: '',
    },
    musculoskeletal: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked5: false,
      etc: '',
    },
    mentalAndBehavioral: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked5: false,
      etc: '',
    },
    respiratory: {
      checked1: false,
      checked2: false,
      checked5: false,
      etc: '',
    },
    renal: {
      checked1: false,
      checked5: false,
      etc: '',
    },
    other: {
      checked1: false,
      checked5: false,
      allergy: '',
      etc: '',
    },
  },
  reason1: '',
  reason2: '',
};

export const initialFall = {
  date: '',
  update_at: '',
  contents: {
    experience: '',
    diagnosis: '',
    walkingAids: '',
    intravenousLine: '',
    gait: '',
    consciousness: '',
  },
};

export const initialFallTwo = {
  date: '',
  update_at: '',
  contents: {
    experience: '',
    diagnosis: '',
    walkingAids: '',
    intravenousLine: '',
    gait: '',
    consciousness: '',
  },
};

export const initialFallThree = {
  update_at: '',
  assessment: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  age: '',
  fall: '',
  evacuation: '',
  drug: '',
  device: '',

  mobility00: false,
  mobility01: false,
  mobility02: false,

  recognition00: false,
  recognition01: false,
  recognition02: false,
};

export const initialPediatric_fall = {
  date: '',
  update_at: '',
  contents: {
    age: '',
    diagnosis: '',
    sex: '',
    cognitive_disorder: '',
    environmental_factors: '',
    medication_use: '',
    surgical_sedative_anesthetic_factors: '',
  },
};

export const initialGCS = {
  date: '',
  update_at: '',
  eye_opening: '',
  verbal_response: '',
  motor_response: '',
};

export const initialPediatric_GCS = {
  date: '',
  update_at: '',
  eye_opening: '',
  verbal_response: '',
  motor_response: '',
};

export const initialFourScore = {
  date: '',
  update_at: '',
  eye_opening: '',
  brainstem_reflexes: '',
  motor_response: '',
  respiration: '',
};

export const initialMaturity = {
  date: '',
  update_at: '',
  physical_maturity: {
    skin: '', // 피부
    lanugo: '', // 솜털
    plantar_surface: '', // 발바닥 주름
    breast: '', // 가슴
    eye_ear: '', // 눈, 귀
    genitals_male: '', // 생식기(남)
    genitals_female: '', // 생식기(여)
  },
  neuromucular_maturity: {
    // 신경근육 성숙도 사정
    posture: '', // 자세
    square_window: '', // 손목각도
    arm_recoil: '', // 팔 되돌아오기 반응
    popliteal_angle: '', // 슬와 각도
    scarf_sign: '', // 스카프징후
    heel_to_ear: '', // 발뒤꿈치 귀 닿기
  },
};

export const initialSafety = {
  update_at: '',
  accident_consequences_details: {
    accidence_date: '',
    accidence_time: '',
    discovery_date: '',
    discovery_time: '',
    discovery_place: '',
    discovery_place_etc: '',
    accident_type: '',
    accident_classification: '',
    accident_classification_etc: '',
  },
  event_classification: '',
  falling_type: {
    consciousness_level: '',
    activity_status: '',
    assisting_devices: '',
    place_falling_accident: '',
    place_falling_accident_etc: '',
    patient_risk_factors: '',
    patient_risk_factors_two: '',
    score: 0,
    date: '',
    fall_type: '',
    risk_factor: '',
    risk_factor_etc: '',
  },
  medication_type: {
    prescription_error: '',
    prescription_error_etc: '',
    drug_preparation_error: '',
    drug_preparation_error_etc: '',
    confirm_error: '',
    interpretation_error: '',
  },
  other_type: '',
  other_type_etc: '',
  accident_detail: '',
  accident_handling: '',
  accident_result: '',
};

export const initialInfection = {
  update_at: '',
  // 1번
  info_name: '',
  info_no: '',
  info_contact: '',
  info_date: '',
  info_department: '',
  info_job: '',
  info_gender: 0,
  info_pregnancy: 0,
  info_pregnancy_input: '',

  // 2번
  infection_matters: {
    checked1: false,
    checked2: false,
  },
  infection_date: '',
  infection_time: '',
  infection_place: '',

  infection_left: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  infection_right: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },

  infection_situation: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
  },
  infection_cause: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
  },
  infection_cause_input: '',

  wear_gloves1: 0,
  wear_gloves2: 0,
  wear_gloves_none: {
    checked1: false,
  },

  // 3번
  infection_state: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },
  infection_state_input: '',

  // 4번
  infection_after: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },
  infection_after_input: '',
  infection_after_medi: '',
  infection_after_test: '',

  // 5번
  test_result: [
    { hbs: '', hiv: '', hcv: '', vdrl: '', rna: '' },
    { hbs: '', hiv: '', hcv: '', vdrl: '', rna: '' },
    { hbs: '', hiv: '', hcv: '', vdrl: '', rna: '' },
    { hbs: '', hiv: '', hcv: '', vdrl: '', rna: '' },
  ],
};

export const initialNRS = {
  update_at: '',
  nrs_survey: [],
};

export const initialFLACC = {
  update_at: '',
  flacc_survey: [],
};

export const initialCNPS = {
  update_at: '',
  face: '',
  activity: '',
  respiratory: '',
  vocalization: '',
  sum: '',
};

export const initialFFI = {
  update_at: '',
  ffi01: 0,
  ffi02: 0,
  ffi03: 0,
  ffi04: 0,
  ffi05: 0,
  ffi06: 0,
  ffi07: 0,
  ffi08: 0,

  ffi09: 0,
  ffi10: 0,
  ffi11: 0,
  ffi12: 0,
  ffi13: 0,
  ffi14: 0,
  ffi15: 0,
  ffi16: 0,
  ffi17: 0,
  ffi18: 0,

  ffi19: 0,
  ffi20: 0,
  ffi21: 0,
  ffi22: 0,
  ffi23: 0,
};

export const initialKOOS = {
  update_at: '',
  spt01: '',
  spt02: '',
  spt03: '',
  spt04: '',
  spt05: '',

  stf01: '',
  stf02: '',

  pain01: '',
  pain02: '',
  pain03: '',
  pain04: '',
  pain05: '',
  pain06: '',
  pain07: '',
  pain08: '',
  pain09: '',

  daily01: '',
  daily02: '',
  daily03: '',
  daily04: '',
  daily05: '',
  daily06: '',
  daily07: '',
  daily08: '',
  daily09: '',
  daily10: '',
  daily11: '',
  daily12: '',
  daily13: '',
  daily14: '',
  daily15: '',
  daily16: '',
  daily17: '',

  actv01: '',
  actv02: '',
  actv03: '',
  actv04: '',
  actv05: '',

  qol01: '',
  qol02: '',
  qol03: '',
  qol04: '',
};

export const initialLEFS = {
  update_at: '',
  lefs01: '',
  lefs02: '',
  lefs03: '',
  lefs04: '',
  lefs05: '',
  lefs06: '',
  lefs07: '',
  lefs08: '',
  lefs09: '',
  lefs10: '',
  lefs11: '',
  lefs12: '',
  lefs13: '',
  lefs14: '',
  lefs15: '',
  lefs16: '',
  lefs17: '',
  lefs18: '',
  lefs19: '',
  lefs20: '',
};

export const initialNDI = {
  update_at: '',
  ndi01: '',
  ndi02: '',
  ndi03: '',
  ndi04: '',
  ndi05: '',
  ndi06: '',
  ndi07: '',
  ndi08: '',
  ndi09: '',
  ndi10: '',
};

export const initialSTarTBack = {
  update_at: '',
  sb01: '',
  sb02: '',
  sb03: '',
  sb04: '',
  sb05: '',
  sb06: '',
  sb07: '',
  sb08: '',
  sb09: '',
};

export const initialK_CPAT = {
  update_at: '',
  no_1: '',

  no_2_a_1: 0,
  no_2_a_2: 0,
  no_2_a_3: 0,
  no_2_a_4: 0,
  no_2_a_5: 0,
  no_2_a_6: 0,

  no_2_b_1: 0,
  no_2_b_2: 0,
  no_2_b_3: 0,
  no_2_b_4: 0,
  no_2_b_5: 0,
  no_2_b_6: 0,

  no_2_c_1: 0,
  no_2_c_2: 0,
  no_2_c_3: 0,
  no_2_c_4: 0,
  no_2_c_5: 0,

  no2_d_input: '',
  no2_d: 0,

  no3: 0,

  no4: {
    check01: false,
    check02: false,
    check03: false,
    check04: false,
    check05: false,
    check06: false,
    check07: false,
    check08: false,
    check09: false,
    check10: false,
    check11: false,
    check12: false,
  },

  no5_1: 3,
  no5_2: 3,
  no5_3: 3,
  no5_4: 3,
  no5_5: 3,
  no5_6: 3,
  no5_7: 3,
  no5_8: 3,
};

export const initialPAINAD_K = {
  update_at: '',
  respiration01: 0,
  shout01: 0,
  face01: 0,
  body01: 0,
  mind01: 0,
  nrs01: 0,
  face_algo01: 0,
  sight_algo01: 0,
  shout_algo01: 0,
  body_algo01: 0,
  action_algo01: 0,

  respiration02: 0,
  shout02: 0,
  face02: 0,
  body02: 0,
  mind02: 0,
  nrs02: 0,
  face_algo02: 0,
  sight_algo02: 0,
  shout_algo02: 0,
  body_algo02: 0,
  action_algo02: 0,

  respiration03: 0,
  shout03: 0,
  face03: 0,
  body03: 0,
  mind03: 0,
  nrs03: 0,
  face_algo03: 0,
  sight_algo03: 0,
  shout_algo03: 0,
  body_algo03: 0,
  action_algo03: 0,
};

export const initialPAINAD_K_none = {
  update_at: '',
  respiration01: 0,
  shout01: 0,
  face01: 0,
  body01: 0,
  mind01: 0,
  face_cpot01: 0,
  body_cpot01: 0,
  voice_cpot01: 0,
  muscle_cpot01: 0,
  face_algo01: 0,
  sight_algo01: 0,
  shout_algo01: 0,
  body_algo01: 0,
  action_algo01: 0,

  respiration02: 0,
  shout02: 0,
  face02: 0,
  body02: 0,
  mind02: 0,
  face_cpot02: 0,
  body_cpot02: 0,
  voice_cpot02: 0,
  muscle_cpot02: 0,
  face_algo02: 0,
  sight_algo02: 0,
  shout_algo02: 0,
  body_algo02: 0,
  action_algo02: 0,

  respiration03: 0,
  shout03: 0,
  face03: 0,
  body03: 0,
  mind03: 0,
  face_cpot03: 0,
  body_cpot03: 0,
  voice_cpot03: 0,
  muscle_cpot03: 0,
  face_algo03: 0,
  sight_algo03: 0,
  shout_algo03: 0,
  body_algo03: 0,
  action_algo03: 0,
};

export const initialMentalNursing = {
  update_at: '',
  mental_survey: [],
};

export const initialMSE = {
  update_at: '',
  extroversion: {
    inpute: '',
    attitude: { checked: [] },
    attitude_two: { checked: [] },
    action: { checked: [] },
    action_two: { checked: [] },
    action_three: { checked: [] },
  },
  language: {
    attitude: { checked: [] },
    productivity: { checked: [] },
    speed: { checked: [] },
    height: { checked: [] },
    ton: { checked: [] },
    obstacle: { checked: [] },
  },
  mood_affect: {
    mood: { value: 3, checked: [] },
    mood_two: { checked: [] },
    affect: { value: 3, checked: [] },
  },
  orientation: {
    hear: { value: 3, input: '' },
    sight: { value: 3, input: '' },
    taste: { value: 3, input: '' },
    touch: { value: 3, input: '' },
    smell: { value: 3, input: '' },
  },
  accident: {
    type_and_course: { value: 3, checked: [] },
    type_and_course_two: { checked: [] },
    detail1: { checked: [] },
    detail1_two: { checked: [] },
    detail2: { checked: [] },
    detail3: { checked: [] },
    detail4: { checked: [], input: '' },
  },
  recognition: {
    time: { value: 3 },
    place: { value: 3 },
    people: { value: 3 },
  },
  memory: {
    past: { value: 3 },
    recent: { value: 3 },
    immediately: { value: 3 },
  },
  attention: {
    focus: { value: 3 },
    mse_abstract: { value: 3 },
  },
  judgement: {
    radio: { value: 3 },
  },
  disease: {
    detail: { value: 3, input: '' },
  },
};

export const initialIoCheckRecord = {
  update_at: '',
  io_survey: [],
};

export const initialBDI = {
  update_at: '',
  content: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  sum: 0,
};

export const initialBAI = {
  update_at: '',
  content: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  sum: 0,
};

export const initialMMSE = {
  update_at: '',
  score: [
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
  ],
  sum: 0,
};

export const initialCIST = {
  update_at: '',
  orientation1: '',
  orientation2: '',
  orientation3: '',
  orientation4: '',
  orientation5: '',
  memory1: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  memory2: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  attention1: '',
  attention2: '',
  attention3: '',
  visual_spatial_ability: '',
  executive_function1_1: '',
  executive_function1_2: '',
  executive_function1_3: '',
  memory3: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
  },
  memory4: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
    checked13: false,
    checked14: false,
    checked15: false,
  },
  language_function1: '',
  language_function2: '',
  language_function3: '',
  language_function4: '',
  executive_function2: '',
};

export const initialKDSQ_P = {
  update_at: '',
  kdsq_p_01: 0,
  kdsq_p_02: 0,
  kdsq_p_03: 0,
  kdsq_p_04: 0,
  kdsq_p_05: 0,
};

export const initialKDSQ_C = {
  update_at: '',
  kdsq_c_01: 0,
  kdsq_c_02: 0,
  kdsq_c_03: 0,
  kdsq_c_04: 0,
  kdsq_c_05: 0,
  kdsq_c_06: 0,
  kdsq_c_07: 0,
  kdsq_c_08: 0,
  kdsq_c_09: 0,
  kdsq_c_10: 0,
  kdsq_c_11: 0,
  kdsq_c_12: 0,
  kdsq_c_13: 0,
  kdsq_c_14: 0,
  kdsq_c_15: 0,
};

export const initialOperation = {
  update_at: '',
  surgery_information: {
    operating_surgeon: '',
    assistant: '',
    scrubbing_nurse: '',
    circulating_nurse: '',
  },
  operation_information: {
    operating_department: '',
    operating_date: '',
    operating_time: '',
    asa_class: '',
    main_operation_name: '',
    minor_operation_name: '',
    past_history: '',
    allergy: '',
    npo_status: '',
    prophylactic_antibiotics: '',
    position: '',
    position_etc: '',
    preoperative_xray: true,
    preoperative_ekg: true,
  },
  surgery_details: {
    content: '',
    arrival_time: '',
    anesthesia_start_time: '',
    surgery_start_time: '',
    surgery_end_time: '',
    anesthesia_end_time: '',
    discharge_time: '',
    anesthetic_method: '',
    anesthetic_method_etc: '',
    anesthesiologist: '',
  },
};

export const initialAnesthesia = {
  update_at: '',
  surgery_information: {
    operating_surgeon: '',
    assistant: '',
    scrubbing_nurse: '',
    circulating_nurse: '',
  },
  operation_information: {
    operating_department: '',
    operating_allergy: '',
    operating_date: '',
    operating_time: '',
    operation_name: '',
    npo_status: '',
    position: '',
    position_etc: '',
    past_history_and_allergy: '',
    preoperative_xray: false,
    preoperative_ekg: false,
    emergency_status: '',
    asa_class: '',
    prophylactic_antibiotics: '',
    prophylactic_method: '',
    prophylactic_method_etc: '',
  },
  prescription_record: [],
  patient_status_record: {
    infusion_amount: '',
    transfusion_amount: '',
    intake_etc: '',
    urine_amount: '',
    blood_clot_amount: '',
    output_etc: '',
  },
  patient_status_list_record: [],
};

export const initialBloodDispensing = {
  update_at: '',
  prescription: '',
  quantity: '',
  date: '',
  name: '',
  sign: '',
};

export const initialTransfusion = {
  update_at: '',
  blood_number: '',
  blood_name: '',
  volume: '',
  arrival_time: '',
  blood_transfusion_arrival: '',
  transfusion_check1: '',
  transfusion_check2: '',
  transfusion_start_time: '',
  practitioner_start: '',
  transfusion_end_time: '',
  practitioner_end: '',
  nursing_implementation: '',
  irradiation: {
    has_irradiation: '',
    content: '',
  },
  filtering: {
    is_compatible: '',
    content: '',
  },
  transfusion_record: [],
};

export const initialRestraint = {
  update_at: '',
  apply: {
    symptoms: {
      check0: false,
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      input: '',
    },
    method: {
      check0: false,
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      check5: false,
      check6: false,
      input: '',
    },
    prescription: { value: 3 },
    category: {
      check0: false,
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      check5: false,
      input: '',
    },
    information: { value: 3, input: '' },
    protection_apply: { date: '', time: '' },
    end_and_reuse: { value: 3, date: '', time: '' },
  },

  table_date: '',

  observation: {
    am_pm0: '',
    hydration0: false,
    skin0: false,
    position0: false,
    commu0: false,
    circul0: false,
    behavior0: false,
    for_removal0: false,
    removal0: false,
    behavior_150: false,
    vital0: false,
    name0: '',
    am_pm1: '',
    hydration1: false,
    skin1: false,
    position1: false,
    commu1: false,
    circul1: false,
    behavior1: false,
    for_removal1: false,
    removal1: false,
    behavior_151: false,
    vital1: false,
    name1: '',
    am_pm2: '',
    hydration2: false,
    skin2: false,
    position2: false,
    commu2: false,
    circul2: false,
    behavior2: false,
    for_removal2: false,
    removal2: false,
    behavior_152: false,
    vital2: false,
    name2: '',
    am_pm3: '',
    hydration3: false,
    skin3: false,
    position3: false,
    commu3: false,
    circul3: false,
    behavior3: false,
    for_removal3: false,
    removal3: false,
    behavior_153: false,
    vital3: false,
    name3: '',
    am_pm4: '',
    hydration4: false,
    skin4: false,
    position4: false,
    commu4: false,
    circul4: false,
    behavior4: false,
    for_removal4: false,
    removal4: false,
    behavior_154: false,
    vital4: false,
    name4: '',
    am_pm5: '',
    hydration5: false,
    skin5: false,
    position5: false,
    commu5: false,
    circul5: false,
    behavior5: false,
    for_removal5: false,
    removal5: false,
    behavior_155: false,
    vital5: false,
    name5: '',
    am_pm6: '',
    hydration6: false,
    skin6: false,
    position6: false,
    commu6: false,
    circul6: false,
    behavior6: false,
    for_removal6: false,
    removal6: false,
    behavior_156: false,
    vital6: false,
    name6: '',
    am_pm7: '',
    hydration7: false,
    skin7: false,
    position7: false,
    commu7: false,
    circul7: false,
    behavior7: false,
    for_removal7: false,
    removal7: false,
    behavior_157: false,
    vital7: false,
    name7: '',
    am_pm8: '',
    hydration8: false,
    skin8: false,
    position8: false,
    commu8: false,
    circul8: false,
    behavior8: false,
    for_removal8: false,
    removal8: false,
    behavior_158: false,
    vital8: false,
    name8: '',
    am_pm9: '',
    hydration9: false,
    skin9: false,
    position9: false,
    commu9: false,
    circul9: false,
    behavior9: false,
    for_removal9: false,
    removal9: false,
    behavior_159: false,
    vital9: false,
    name9: '',
    am_pm10: '',
    hydration10: false,
    skin10: false,
    position10: false,
    commu10: false,
    circul10: false,
    behavior10: false,
    for_removal10: false,
    removal10: false,
    behavior_1510: false,
    vital10: false,
    name10: '',
    am_pm11: '',
    hydration11: false,
    skin11: false,
    position11: false,
    commu11: false,
    circul11: false,
    behavior11: false,
    for_removal11: false,
    removal11: false,
    behavior_1511: false,
    vital11: false,
    name11: '',
  },
};

export const initialCPR = {
  update_at: '',
  find_place: '',
  cpr_place: '',
  cpr_leader: '',
  writer: '',
  find_date: '',
  find_time: '',
  terminate_reason: '',
  clinical_observation: {
    bp0: '',
    hr0: '',
    rr0: '',
    bt0: '',
    spo20: '',
    consciousness0: '',
    pupil_size0: '',
    pupil_reflex0: '',
    cardio_ryt0: '',
    bp1: '',
    hr1: '',
    rr1: '',
    bt1: '',
    spo21: '',
    consciousness1: '',
    pupil_size1: '',
    pupil_reflex1: '',
    cardio_ryt1: '',
    bp2: '',
    hr2: '',
    rr2: '',
    bt2: '',
    spo22: '',
    consciousness2: '',
    pupil_size2: '',
    pupil_reflex2: '',
    cardio_ryt2: '',
    bp3: '',
    hr3: '',
    rr3: '',
    bt3: '',
    spo23: '',
    consciousness3: '',
    pupil_size3: '',
    pupil_reflex3: '',
    cardio_ryt3: '',
    bp4: '',
    hr4: '',
    rr4: '',
    bt4: '',
    spo24: '',
    consciousness4: '',
    pupil_size4: '',
    pupil_reflex4: '',
    cardio_ryt4: '',
    bp5: '',
    hr5: '',
    rr5: '',
    bt5: '',
    spo25: '',
    consciousness5: '',
    pupil_size5: '',
    pupil_reflex5: '',
    cardio_ryt5: '',
    bp6: '',
    hr6: '',
    rr6: '',
    bt6: '',
    spo26: '',
    consciousness6: '',
    pupil_size6: '',
    pupil_reflex6: '',
    cardio_ryt6: '',
    bp7: '',
    hr7: '',
    rr7: '',
    bt7: '',
    spo27: '',
    consciousness7: '',
    pupil_size7: '',
    pupil_reflex7: '',
    cardio_ryt7: '',
    bp8: '',
    hr8: '',
    rr8: '',
    bt8: '',
    spo28: '',
    consciousness8: '',
    pupil_size8: '',
    pupil_reflex8: '',
    cardio_ryt8: '',
    bp9: '',
    hr9: '',
    rr9: '',
    bt9: '',
    spo29: '',
    consciousness9: '',
    pupil_size9: '',
    pupil_reflex9: '',
    cardio_ryt9: '',
    bp10: '',
    hr10: '',
    rr10: '',
    bt10: '',
    spo210: '',
    consciousness10: '',
    pupil_size10: '',
    pupil_reflex10: '',
    cardio_ryt10: '',
    bp11: '',
    hr11: '',
    rr11: '',
    bt11: '',
    spo211: '',
    consciousness11: '',
    pupil_size11: '',
    pupil_reflex11: '',
    cardio_ryt11: '',
    bp12: '',
    hr12: '',
    rr12: '',
    bt12: '',
    spo212: '',
    consciousness12: '',
    pupil_size12: '',
    pupil_reflex12: '',
    cardio_ryt12: '',
    bp13: '',
    hr13: '',
    rr13: '',
    bt13: '',
    spo213: '',
    consciousness13: '',
    pupil_size13: '',
    pupil_reflex13: '',
    cardio_ryt13: '',
    bp14: '',
    hr14: '',
    rr14: '',
    bt14: '',
    spo214: '',
    consciousness14: '',
    pupil_size14: '',
    pupil_reflex14: '',
    cardio_ryt14: '',
    bp15: '',
    hr15: '',
    rr15: '',
    bt15: '',
    spo215: '',
    consciousness15: '',
    pupil_size15: '',
    pupil_reflex15: '',
    cardio_ryt15: '',
    bp16: '',
    hr16: '',
    rr16: '',
    bt16: '',
    spo216: '',
    consciousness16: '',
    pupil_size16: '',
    pupil_reflex16: '',
    cardio_ryt16: '',
    bp17: '',
    hr17: '',
    rr17: '',
    bt17: '',
    spo217: '',
    consciousness17: '',
    pupil_size17: '',
    pupil_reflex17: '',
    cardio_ryt17: '',
    bp18: '',
    hr18: '',
    rr18: '',
    bt18: '',
    spo218: '',
    consciousness18: '',
    pupil_size18: '',
    pupil_reflex18: '',
    cardio_ryt18: '',
    bp19: '',
    hr19: '',
    rr19: '',
    bt19: '',
    spo219: '',
    consciousness19: '',
    pupil_size19: '',
    pupil_reflex19: '',
    cardio_ryt19: '',
    bp20: '',
    hr20: '',
    rr20: '',
    bt20: '',
    spo220: '',
    consciousness20: '',
    pupil_size20: '',
    pupil_reflex20: '',
    cardio_ryt20: '',
    bp21: '',
    hr21: '',
    rr21: '',
    bt21: '',
    spo221: '',
    consciousness21: '',
    pupil_size21: '',
    pupil_reflex21: '',
    cardio_ryt21: '',
  },
  treatment: {
    chest_compression0: '',
    artificial_ventilation0: '',
    aed0: '',
    chest_compression1: '',
    artificial_ventilation1: '',
    aed1: '',
    chest_compression2: '',
    artificial_ventilation2: '',
    aed2: '',
    chest_compression3: '',
    artificial_ventilation3: '',
    aed3: '',
    chest_compression4: '',
    artificial_ventilation4: '',
    aed4: '',
    chest_compression5: '',
    artificial_ventilation5: '',
    aed5: '',
    chest_compression6: '',
    artificial_ventilation6: '',
    aed6: '',
    chest_compression7: '',
    artificial_ventilation7: '',
    aed7: '',
    chest_compression8: '',
    artificial_ventilation8: '',
    aed8: '',
    chest_compression9: '',
    artificial_ventilation9: '',
    aed9: '',
    chest_compression10: '',
    artificial_ventilation10: '',
    aed10: '',
    chest_compression11: '',
    artificial_ventilation11: '',
    aed11: '',
    chest_compression12: '',
    artificial_ventilation12: '',
    aed12: '',
    chest_compression13: '',
    artificial_ventilation13: '',
    aed13: '',
    chest_compression14: '',
    artificial_ventilation14: '',
    aed14: '',
    chest_compression15: '',
    artificial_ventilation15: '',
    aed15: '',
    chest_compression16: '',
    artificial_ventilation16: '',
    aed16: '',
    chest_compression17: '',
    artificial_ventilation17: '',
    aed17: '',
    chest_compression18: '',
    artificial_ventilation18: '',
    aed18: '',
    chest_compression19: '',
    artificial_ventilation19: '',
    aed19: '',
    chest_compression20: '',
    artificial_ventilation20: '',
    aed20: '',
    chest_compression21: '',
    artificial_ventilation21: '',
    aed21: '',
  },
  intubation: {
    id0: '',
    depth0: '',
    balloon0: '',
    practitioner0: '',
    id1: '',
    depth1: '',
    balloon1: '',
    practitioner1: '',
    id2: '',
    depth2: '',
    balloon2: '',
    practitioner2: '',
    id3: '',
    depth3: '',
    balloon3: '',
    practitioner3: '',
    id4: '',
    depth4: '',
    balloon4: '',
    practitioner4: '',
    id5: '',
    depth5: '',
    balloon5: '',
    practitioner5: '',
    id6: '',
    depth6: '',
    balloon6: '',
    practitioner6: '',
    id7: '',
    depth7: '',
    balloon7: '',
    practitioner7: '',
    id8: '',
    depth8: '',
    balloon8: '',
    practitioner8: '',
    id9: '',
    depth9: '',
    balloon9: '',
    practitioner9: '',
    id10: '',
    depth10: '',
    balloon10: '',
    practitioner10: '',
    id11: '',
    depth11: '',
    balloon11: '',
    practitioner11: '',
    id12: '',
    depth12: '',
    balloon12: '',
    practitioner12: '',
    id13: '',
    depth13: '',
    balloon13: '',
    practitioner13: '',
    id14: '',
    depth14: '',
    balloon14: '',
    practitioner14: '',
    id15: '',
    depth15: '',
    balloon15: '',
    practitioner15: '',
    id16: '',
    depth16: '',
    balloon16: '',
    practitioner16: '',
    id17: '',
    depth17: '',
    balloon17: '',
    practitioner17: '',
    id18: '',
    depth18: '',
    balloon18: '',
    practitioner18: '',
    id19: '',
    depth19: '',
    balloon19: '',
    practitioner19: '',
    id20: '',
    depth20: '',
    balloon20: '',
    practitioner20: '',
    id21: '',
    depth21: '',
    balloon21: '',
    practitioner21: '',
  },
  medication: {
    no00_1: '',
    no00_2: '',
    no00_3: '',
    no00_4: '',
    no00_5: '',
    no00_6: '',
    no00_7: '',
    no00_12: '',
    no00_13: '',
    no00_14: '',
    no00_15: '',
    no00_16: '',
    no00_17: '',
    no00_18: '',
    no0_1: '',
    no0_2: '',
    no0_3: '',
    no0_4: '',
    no0_5: '',
    no0_6: '',
    no0_7: '',
    no1_1: '',
    no1_2: '',
    no1_3: '',
    no1_4: '',
    no1_5: '',
    no1_6: '',
    no1_7: '',
    no2_1: '',
    no2_2: '',
    no2_3: '',
    no2_4: '',
    no2_5: '',
    no2_6: '',
    no2_7: '',
    no3_1: '',
    no3_2: '',
    no3_3: '',
    no3_4: '',
    no3_5: '',
    no3_6: '',
    no3_7: '',
    no4_1: '',
    no4_2: '',
    no4_3: '',
    no4_4: '',
    no4_5: '',
    no4_6: '',
    no4_7: '',
    no5_1: '',
    no5_2: '',
    no5_3: '',
    no5_4: '',
    no5_5: '',
    no5_6: '',
    no5_7: '',
    no6_1: '',
    no6_2: '',
    no6_3: '',
    no6_4: '',
    no6_5: '',
    no6_6: '',
    no6_7: '',
    no7_1: '',
    no7_2: '',
    no7_3: '',
    no7_4: '',
    no7_5: '',
    no7_6: '',
    no7_7: '',
    no8_1: '',
    no8_2: '',
    no8_3: '',
    no8_4: '',
    no8_5: '',
    no8_6: '',
    no8_7: '',
    no9_1: '',
    no9_2: '',
    no9_3: '',
    no9_4: '',
    no9_5: '',
    no9_6: '',
    no9_7: '',
    no10_1: '',
    no10_2: '',
    no10_3: '',
    no10_4: '',
    no10_5: '',
    no10_6: '',
    no10_7: '',
    no10__1: '',
    no10__2: '',
    no10__3: '',
    no10__4: '',
    no10__5: '',
    no10__6: '',
    no10__7: '',
    no11_1: '',
    no11_2: '',
    no11_3: '',
    no11_4: '',
    no11_5: '',
    no11_6: '',
    no11_7: '',
    no12_1: '',
    no12_2: '',
    no12_3: '',
    no12_4: '',
    no12_5: '',
    no12_6: '',
    no12_7: '',
    no13_1: '',
    no13_2: '',
    no13_3: '',
    no13_4: '',
    no13_5: '',
    no13_6: '',
    no13_7: '',
    no14_1: '',
    no14_2: '',
    no14_3: '',
    no14_4: '',
    no14_5: '',
    no14_6: '',
    no14_7: '',
    no15_1: '',
    no15_2: '',
    no15_3: '',
    no15_4: '',
    no15_5: '',
    no15_6: '',
    no15_7: '',
    no16_1: '',
    no16_2: '',
    no16_3: '',
    no16_4: '',
    no16_5: '',
    no16_6: '',
    no16_7: '',
    no17_1: '',
    no17_2: '',
    no17_3: '',
    no17_4: '',
    no17_5: '',
    no17_6: '',
    no17_7: '',
    no18_1: '',
    no18_2: '',
    no18_3: '',
    no18_4: '',
    no18_5: '',
    no18_6: '',
    no18_7: '',
    no19_1: '',
    no19_2: '',
    no19_3: '',
    no19_4: '',
    no19_5: '',
    no19_6: '',
    no19_7: '',
    no20_1: '',
    no20_2: '',
    no20_3: '',
    no20_4: '',
    no20_5: '',
    no20_6: '',
    no20_7: '',
    no21_1: '',
    no21_2: '',
    no21_3: '',
    no21_4: '',
    no21_5: '',
    no21_6: '',
    no21_7: '',
  },
  test: {
    abga0: false,
    chest0: false,
    lab0: false,
    abga1: false,
    chest1: false,
    lab1: false,
    abga2: false,
    chest2: false,
    lab2: false,
    abga3: false,
    chest3: false,
    lab3: false,
    abga4: false,
    chest4: false,
    lab4: false,
    abga5: false,
    chest5: false,
    lab5: false,
    abga6: false,
    chest6: false,
    lab6: false,
    abga7: false,
    chest7: false,
    lab7: false,
    abga8: false,
    chest8: false,
    lab8: false,
    abga9: false,
    chest9: false,
    lab9: false,
    abga10: false,
    chest10: false,
    lab10: false,
    abga11: false,
    chest11: false,
    lab11: false,
    abga12: false,
    chest12: false,
    lab12: false,
    abga13: false,
    chest13: false,
    lab13: false,
    abga14: false,
    chest14: false,
    lab14: false,
    abga15: false,
    chest15: false,
    lab15: false,
    abga16: false,
    chest16: false,
    lab16: false,
    abga17: false,
    chest17: false,
    lab17: false,
    abga18: false,
    chest18: false,
    lab18: false,
    abga19: false,
    chest19: false,
    lab19: false,
    abga20: false,
    chest20: false,
    lab20: false,
    abga21: false,
    chest21: false,
    lab21: false,
  },
};

export const initialDialysis = {
  update_at: '',
  date: '',
  time: '',
  dialyzer: '',
  dialysis_machine: '',
  visiting_route: '',
  visiting_route_etc: '',
  dialysate: '',
  vascular_access: '',
  vascular_access_etc: '',
  starting_nurse: '',
  ending_nurse: '',
  pre_previous_weight: '',
  pre_today_weight: '',
  pre_weight_change: '',
  post_previous_weight: '',
  post_today_weight: '',
  post_weight_change: '',
  dialysis_db: [],
  crrt: [],
  additional_information: '',
};

export const initialIntubation = {
  update_at: '',
  cline_information: [],
  aline_information: [],
  foley_information: [],
  avf_information: [],
  hd_information: [],
  etube_information: [],
};

export const initialEmergency = {
  update_at: '',
  emergency_information: {
    accident_date: '',
    accident_time: '',
    visit_method: '',
    memo: '',
    arrival_time: '',
  },
  emergency_patient_information: {
    symptom: '',
    etc_symptom: '',
    damage: '',
    intentional: '',
    medical_conditions: '',
    history: '',
    allergy: '',
    medication: '',
    consciousness: '',
    gcs: '',
    motor: '',
    pupil: '',
    nrs: '',
    pqrst: '',
    ktas: '',
    expected_diagnosis: '',
  },
  patient_status_record: {
    infusion_amount: '',
    transfusion_amount: '',
    intake_etc: '',
    urine_amount: '',
    blood_clot_amount: '',
    output_etc: '',
  },
  patient_status_list_record: [],
  emergency_care_result: {
    result: { value: 1, input: '' },
    status: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      placeholder: '',
    },
  },
};

export const initialChildbirth = {
  update_at: '',
  child_birth_information: {
    date: '',
    time: '',
    type: '',
  },
  newborn_condition: {
    gender: -1,
    weight: '',
    apgar_score1m: '',
    apgar_score5m: '',
    oxygen_intake: -1,
    first_urine: -1,
    placenta_discharge: -1,
    fetal_staining: -1,
    nuchal_cord: -1,
    nuchal_cord_content: '',
    resuscitation: -1,
    resuscitation_content: '',
    specifications: '',
  },
  apgar: {
    appearance: -1,
    pulse: -1,
    grimace: -1,
    activity: -1,
    respiration: -1,
  },
  placenta_removal: {
    time: '',
    methods: -1,
    curettage: -1,
  },
  maternal_condition: {
    episiotomy: -1,
    episiotomy_content: '',
    perineal_laceration: -1,
    perineal_laceration_content: '',
    uterus_contraction: '',
  },
  nursing_records: [],
};

export const initialHomeCare = {
  update_at: '',
  basic_information: {
    occupation: '',
    insurance_type: '',
    residence: '',
    residence_etc: '',
    religion: '',
    nursing_provider: '',
    sanitary: '',
    sanitary_notes: '',
    marital_status: '',
    past_history: '',
    safety: '',
    safety_notes: '',
  },
  request_status: [],
  inspection_findings: [],
  medication_records: [],
  need_service: '',
};

export const initialECMO = {
  update_at: '',
  treatment_place: {
    place_radio: '',
    place_input: '',
  },
  treatment_reason: {
    indications: '',
    va_shock_reason: '',
    va_shock_reason_input: '',
    va_shock_condition: '',
    va_shock_condition_input1: '',
    va_shock_condition_input2: '',
    va_arrest: '',
    va_arrest_input1: '',
    va_arrest_input2: '',
    va_arrest_input3: '',
    va_arrest_input4: '',
    va_arrest_lvad: '',
    va_arrest_reason: '',
  },
  reason_vv_ecmo: '',
  summation: '',
  inhibition_check: '',
  inhibition1: '',
  inhibition2: '',
  inhibition3: '',
  inhibition4: '',
  inhibition5: '',
  inhibition6: '',
  inhibition7: '',
  inhibition8: '',
  inhibition9: '',
  inhibition10: '',
  inhibition11: '',
  special_reason: '',
};

export const initialEcmo = {
  update_at: '',
  treatment_place: {
    place_radio: '',
    place_input: '',
  },
  treatment_reasone: {
    indications: '',
    va_shock_reasone: '',
    va_shock_reasone_input: '',
    va_shock_condition: '',
    va_shock_condition_input1: '',
    va_shock_condition_input2: '',

    va_arrest: '',
    va_arrest_input1: '',
    va_arrest_input2: '',
    va_arrest_input3: '',
    va_arrest_input4: '',
    va_arrest_lvad: '',
    va_arrest_reasone: '',
  },
  reasone_vv_ecmo: '',

  summation: '',

  inhibition_check: '',

  inhibition1: '',
  inhibition2: '',
  inhibition3: '',
  inhibition4: '',
  inhibition5: '',
  inhibition6: '',
  inhibition7: '',
  inhibition8: '',
  inhibition9: '',
  inhibition10: '',
  inhibition11: '',

  special_reasone: '',
};

export const initialKPCS = {
  date: '',
  update_at: '',
  no01: 0,
  no02: 0,
  no03: 0,
  no04: 0,
  no05: 0,
  no06: 0,
  no07: 0,
  no08: 0,
  no09: 0,
  no10: 0,
  no11: 0,
  no12: 0,
  no13: 0,
  no14: 0,
  no15: 0,
  no16: 0,
  no17: 0,
  no18: 0,
  no19: 0,
  no20: 0,
  no21: 0,
  no22: 0,
  no22_1: 0,
  no23: 0,
  no23_1: 0,
  no24: 0,
  no25: 0,
  no26: 0,
  no27: 0,
  no28: 0,
  no29: 0,
  no30: 0,
  no31: 0,
  no32: 0,
  no32_1: 0,
  no33: 0,
  no34: 0,
  no35: 0,
  no36: 0,
  no37: 0,
  no38: 0,
  no39: 0,
  no40: 0,
  no41: 0,
  no42: 0,
  no43: 0,
  no44: 0,
  no45: 0,
  no46: 0,
  no47: 0,
  no47_1: 0,
  no48: 0,
  no49: 0,
  no50: 0,
};

export const initialKPCSC = {
  date: '',
  update_at: '',
  no01: 0,
  no02: 0,
  no03: 0,
  no04: 0,
  no05: 0,
  no06: 0,
  no07: 0,
  no08: 0,
  no08_1: 0,
  no09: 0,
  no10: 0,
  no11: 0,
  no12: 0,
  no13: 0,
  no14: 0,
  no15: 0,
  no16: 0,
  no17: 0,
  no18: 0,
  no18_1: 0,
  no19: 0,
  no20: 0,
  no21: 0,
  no22: 0,
  no23: 0,
  no24: 0,
  no25: 0,
  no26: 0,
  no27: 0,
  no28: 0,
  no29: 0,
  no29_1: 0,
  no30: 0,
  no31: 0,
  no32: 0,
  no33: 0,
  no34: 0,
  no35: 0,
  no35_1: 0,
  no36: 0,
  no36_1: 0,
  no37: 0,
  no38: 0,
  no39: 0,
  no40: 0,
  no41: 0,
  no41_1: 0,
  no42: 0,
  no42_1: 0,
  no43: 0,
  no44: 0,
  no45: 0,
  no46: 0,
  no47: 0,
  no48: 0,
  no49: 0,
  no49_1: 0,
  no50: 0,
  no50_1: 0,
  no51: 0,
  no51_1: 0,
  no52: 0,
  no52_1: 0,
  no53: 0,
  no53_1: 0,
  no54: 0,
  no54_1: 0,
  no55: 0,
  no55_1: 0,
  no56: 0,
  no56_1: 0,
  no57: 0,
  no57_1: 0,
  no58: 0,
  no58_1: 0,
  no59: 0,
  no59_1: 0,
  no60: 0,
  no60_1: 0,
  no61: 0,
  no62_1: 0,
  no62: 0,
  no63_1: 0,
  no63: 0,
  no64: 0,
  no65_1: 0,
  no65: 0,
  no66: 0,
  no67: 0,
  no68: 0,
  no69: 0,
  no70_1: 0,
  no70: 0,
  no71: 0,
  no72: 0,
  no73_1: 0,
  no73: 0,
  no74: 0,
  no75: 0,
  no76: 0,
  no77: 0,
  no78: 0,
  no79: 0,
  no80: 0,
  no81: 0,
  no82: 0,
  no82_1: 0,
  no83: 0,
};

export const initialKPCSN = {
  date: '',
  update_at: '',
  no01: 0,
};

export const initialKPCS_GW = {
  date: '',
  update_at: '',
  no01: 0,
  no02: 0,
  no03: 0,
  no04: 0,
  no05: 0,
  no06: 0,
  no07: 0,
  no08: 0,
  no09: 0,
  no10: 0,
  no11: 0,
  no12: 0,
  no13: 0,
  no14: 0,
  no15: 0,
  no16: 0,
  no17: 0,
  no18: 0,
  no19: 0,
  no20: 0,
  no21: 0,
  no22: 0,
  no23: 0,
  no24: 0,
  no24_1: 0,
  no25: 0,
  no26: 0,
  no27: 0,
  no28: 0,
  no29: 0,
  no30: 0,
  no31: 0,
  no32: 0,
  no33: 0,
  no34: 0,
};

export const initialKPCS_ICU = {
  date: '',
  update_at: '',
  no01: 0,
  no02: 0,
  no03: 0,
  no04: 0,
  no05: 0,
  no06: 0,
  no07: 0,
  no08: 0,
  no09: 0,
  no10: 0,
  no11: 0,
  no12: 0,
  no13: 0,
  no14: 0,
  no15: 0,
  no16: 0,
  no17: 0,
  no18: 0,
  no19: 0,
  no20: 0,
  no21: 0,
  no22: 0,
  no23: 0,
  no24: 0,
  no25: 0,
  no26: 0,
  no27: 0,
  no28: 0,
  no29: 0,
  no30: 0,
  no30_1: 0,
  no31: 0,
  no32: 0,
  no33: 0,
  no33_1: 0,
  no34: 0,
  no34_1: 0,
  no35: 0,
  no36: 0,
  no37: 0,
  no38: 0,
  no39: 0,
  no40: 0,
  no40_1: 0,
  no41: 0,
  no41_1: 0,
  no42: 0,
  no43: 0,
  no43_1: 0,
  no44: 0,
  no45: 0,
  no45_1: 0,
  no46: 0,
  no47: 0,
  no47_1: 0,
  no48: 0,
  no48_1: 0,
  no49: 0,
  no49_1: 0,
  no50: 0,
  no50_1: 0,
  no51: 0,
  no51_1: 0,
  no52: 0,
  no53: 0,
  no54: 0,
  no55: 0,
  no56: 0,
  no57: 0,
  no58: 0,
  no58_1: 0,
  no59: 0,
  no60: 0,
  no61: 0,
  no61_1: 0,
  no62: 0,
  no62_1: 0,
  no63: 0,
  no64: 0,
  no65: 0,
  no66: 0,
  no67: 0,
  no68: 0,
  no69: 0,
  no70: 0,
  no71: 0,
  no72: 0,
  no73: 0,
  no74: 0,
  no75: 0,
  no76: 0,
  no77: 0,
  no77_1: 0,
  no78: 0,
  no79: 0,
  no80: 0,
  no81: 0,
  no82: 0,
  no82_1: 0,
  no83: 0,
};

export const initialKPCSC_NICU = {
  date: '',
  update_at: '',
  no01: 0,
};

export const initialNursingNeed = {
  update_at: '',
  no01_organization_name: '',
  no01_ward_code: '',
  no01_date: '',
  no01_name: '',
  no01_dept: '',
  no01_contact: '',

  no02_02: 1,
  no02_03: 1,
  no02_04: '',
  no02_05: 1,
  no02_06: '',
  no02_07: 1,

  no03_01: 1,
  no03_02: 1,
  no03_03: 1,
  no03_04: 1,
  no03_05: 1,
  no03_06: 1,
  no03_07: 1,
  no03_08: 1,
  no03_09: 1,
  no03_10: 1,
  no03_11: 1,
  no03_12: 1,
  no03_13: 1,
  no03_14: 1,

  no04_01: 1,
  no04_02: 1,
  no04_03: 1,
  no04_04: 1,
  no04_05: 1,
  no04_06: 1,
  no04_07: 1,

  no05_01: 1,

  no06_01: 1,
  no06_02: 1,
};

export const initialDietList = {
  update_at: '',
  birth: '',
  classification: 1,

  //  조식
  break_fast: {
    calorie: 0,
    guardian_meal: false,
    default_diet: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
    },
    treatment: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
      checked25: false,
      checked26: false,
      checked27: false,
      checked28: false,
      checked29: false,
      checked30: false,
      checked31: false,
      checked32: false,
      checked33: false,
      checked34: false,
      checked35: false,
      checked36: false,
      checked37: false,
      checked38: false,
      checked39: false,
      checked40: false,
      checked41: false,
      checked42: false,
      checked43: false,
      checked44: false,
    },
    special: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
    },
  },
  lunch: {
    calorie: 0,
    guardian_meal: false,
    default_diet: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
    },
    treatment: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
      checked25: false,
      checked26: false,
      checked27: false,
      checked28: false,
      checked29: false,
      checked30: false,
      checked31: false,
      checked32: false,
      checked33: false,
      checked34: false,
      checked35: false,
      checked36: false,
      checked37: false,
      checked38: false,
      checked39: false,
      checked40: false,
      checked41: false,
      checked42: false,
      checked43: false,
      checked44: false,
    },
    special: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
    },
  },
  dinner: {
    calorie: 0,
    guardian_meal: false,
    default_diet: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
    },
    treatment: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
      checked25: false,
      checked26: false,
      checked27: false,
      checked28: false,
      checked29: false,
      checked30: false,
      checked31: false,
      checked32: false,
      checked33: false,
      checked34: false,
      checked35: false,
      checked36: false,
      checked37: false,
      checked38: false,
      checked39: false,
      checked40: false,
      checked41: false,
      checked42: false,
      checked43: false,
      checked44: false,
    },
    special: {
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      checked5: false,
      checked6: false,
      checked7: false,
      checked8: false,
      checked9: false,
      checked10: false,
      checked11: false,
      checked12: false,
      checked13: false,
      checked14: false,
      checked15: false,
      checked16: false,
      checked17: false,
      checked18: false,
      checked19: false,
      checked20: false,
      checked21: false,
      checked22: false,
      checked23: false,
      checked24: false,
    },
  },
};

export const initialHospitalConfirm = {
  update_at: '',
  nursing_care: {
    checked1: false,
  },
  facilities_in: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
  },
  facilities: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
    checked11: false,
    checked12: false,
    checked13: false,
    checked14: false,
    checked15: false,
    checked16: false,
  },
  name: '',
  relationship: '',
  signature: '',
  date: '',
  personnel_signature: '',
};

// 입퇴원동의서
export const initialAdmissionAndDischarge = {
  update_at: '',
  date: '',
  patient_name: '',
  patient_sig: '',

  guardian_name: '',
  guardian_sig: '',
  guardian_birth: '',
  guardian_phone: '',
};

// 입퇴원동의서
export const initialSelfDischarge = {
  update_at: '',
  patient_relationship: '',
  patient_name: '',

  date: '',

  consenter_relationship: '',
  consenter_name: '',
  consenter_sig: '',

  attestor_spot: '',
  attestor_name: '',
  attestor_sig: '',
};

export const initialFallConfirm = {
  update_at: '',
  fall_education: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
  },
  signature: '',
  date: '',
  personnel_signature: '',
};

export const initialTransfusionAgree = {
  update_at: '',
  pt_bday: '',
  pt_contact: '',
  pt_name: '',
  pt_sig: '',

  representative_bday: '',
  representative_contact: '',
  representative_name: '',
  representative_sig: '',

  dr_name: '',
  dr_sig: '',
};

export const initialIntubationAgree = {
  update_at: '',
  no4: '',

  date: '',
  relationship: '',
  name: '',
  sign: '',

  dr_name: '',
  dr_sign: '',
};

export const initialCRRT = {
  update_at: '',
  no1_1: '',
  no1_2: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
    checked7: false,
    checked8: false,
    checked9: false,
    checked10: false,
  },
  no1_3: '',

  no2: '',
  no3_1: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
    checked5: false,
    checked6: false,
  },

  date: '',
  relationship: '',
  name: '',
  applier_contact: '',
  sign: '',
};

export const initialCentralVenous = {
  update_at: '',
  no1: {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  },

  pt_bday: '',
  pt_contact: '',
  pt_name: '',
  pt_sign: '',

  nok_bday: '',
  nok_contact: '',
  nok_name: '',
  nok_sign: '',

  dr_name: '',
  dr_sign: '',
};

export const initialColonoscopy = {
  update_at: '',
  agree_check_01: '',
  agree_check_02: '',
  patient_bday: '',
  patient_contact: '',
  patient_name: '',
  patient_sig: '',
  companion_bday: '',
  companion_contact: '',
  companion_name: '',
  companion_sig: '',
  dr_name: '',
  dr_sig: '',
};

export const initialUpperEndoscopy = {
  update_at: '',
  agree_check: '',
  patient_bday: '',
  patient_contact: '',
  patient_name: '',
  patient_sig: '',
  companion_bday: '',
  companion_contact: '',
  companion_name: '',
  companion_sig: '',
  dr_name: '',
  dr_sig: '',
};

export const initialNonSalary = {
  update_at: '',
  item_01: '',
  fee_01: '',
  no_01: true,

  item_02: '',
  fee_02: '',
  no_02: true,

  item_03: '',
  fee_03: '',
  no_03: true,

  item_04: '',
  fee_04: '',
  no_04: true,

  date: '',
  name: '',
  sig: '',
};

// 수술동의서
export const initialConsentForSurgery = {
  update_at: '',
  select_category: {
    surgery: '',
    screening: '',
    anesthesia: '',
  },
  surgery_start_date: '',
  on_call: '',
  disease_name: '',
  surgery_name: '',
  main_doctor_name: '',
  main_doctor_sign: '',
  past_disease: {
    select: '',
    content: '',
  },
  special_constitution: {
    select: '',
    content: '',
  },
  blood_pressure: {
    select: '',
    content: '',
  },
  heart_disease: {
    select: '',
    content: '',
  },
  accident_caused_by_medicine: {
    select: '',
    content: '',
  },
  allergy: {
    select: '',
    content: '',
  },
  diabete: {
    select: '',
    content: '',
  },
  blood_cause: {
    select: '',
    content: '',
  },
  drug_accident: {
    select: '',
    content: '',
  },
  address: '',
  phone: '',
  personal_number: '',
  created_date: '',
  patient_name: '',
  patient_sign: '',
  next_of_kin_name: '',
  next_of_kin_sign: '',
};

export const initialMedicalRecords = {
  update_at: '',
  pt_name: '',
  pt_ssn: '',
  pt_addr: '',
  pt_contact: '',

  applier_name: '',
  applier_relp: '',
  applier_bday: '',
  applier_contact: '',
  applier_addr: '',

  scope_center: '',
  scope_period_from: '',
  scope_period_to: '',
  scope_reason: '',
  scope_detail: '',

  date: '',
  name: '',
  sig: '',
};

export const initialSuppressor = {
  update_at: '',
  no2_1: '',
  no2_2: '',
  no2_3: '',
  no2_4: '',
  no2_5: '',
  no2_dr_name: '',
  no2_dr_sign: '',

  no3_check_01: false,
  no3_check_02: false,
  no3_check_03: false,
  no3_check_04: false,

  no3_input_box: '',
  date: '',
  relationship: '',
  name: '',
  sign: '',
  dr_name: '',
  dr_sign: '',
  ns_name: '',
  ns_sign: '',
};

export const initialDNR = {
  update_at: '',
  pt_name: '',
  pt_ssn: '',
  pt_addr: '',
  pt_contact: '',

  willing: '', //호스피스 이용 의향

  explanation01: false,
  explanation02: false,
  explanation03: false,
  explanation04: false,
  explanation05: false,
  explanation06: false,

  explanation_check: '',
  explanation_check_sig_date: '',
  explanation_check_sig_name: '',
  explanation_check_sig_sig: '',

  pt_available: '',
  pt_available_etc_memo: '',

  center_name: '',
  center_location: '',
  center_consultant: '',
  center_contact: '',

  recorde_date: '',
  recorde_person_name: '',
  recorde_person_sig: '',

  register_date: '',
  register_person_name: '',
  register_person_sig: '',
};

export const initialDNRTwo = {
  update_at: '',
  check: false,

  no1_name: '',
  no1_relationship: '',
  no1_id: '',
  no1_contact: '',
  no1_sig: '',

  no2_name: '',
  no2_relationship: '',
  no2_id: '',
  no2_contact: '',
  no2_sig: '',

  no3_name: '',
  no3_relationship: '',
  no3_id: '',
  no3_contact: '',
  no3_sig: '',

  doc_name: '',
  doc_sig: '',
  doc_license_no: '',
  specialist_license_no: '',

  specialist_name: '',
  specialist_sig: '',
  specialist_specialty: '',
  specialist_institute: '',
};

export const initialDNA = {
  update_at: '',
  test_object_name: '',
  test_object_ssn: '',
  test_object_addr: '',
  test_object_contact: '',

  legal_representative_name: '',
  legal_representative_ssn: '',
  legal_representative_addr: '',
  legal_representative_contact: '',

  lab_name: '',
  lab_contact: '',

  pt_purpose: '',
  pt_test: '',

  date: '',
  testee_name: '',
  testee_sig: '',
  representative_name: '',
  representative_sig: '',
  consultant_name: '',
  consultant_sig: '',
};

export const initialSubmitAssignment = {
  update_at: '',
  file: [],
  file2: [],
  file3: [],
};

export const initialMinor = {
  update_at: '',
  guardian_name1: '',
  guardian_birth: '',
  guardian_contact: '',
  guardian_address: '',
  guardian_relation: '',

  procedure_date: '',
  procedure_content: '',

  date: '',
  patient_name: '',
  patient_sig: '',
  guardian_name2: '',
  guardian_sig: '',
};

export const initialCoreNursingSkillVideo = {
  update_at: '',
  file: [],
  file2: [],
  file3: [],
};

export const initialCoreNursingSkillVideoExemple = {
  update_at: '',
  files: [],
};

export const initialCheckListRoom = {
  update_at: '',
  info_info01: '',
  info_info02: '',
  info_info03: '',

  info_mental01: '',

  fall01: '',
  fall02: '',
  fall03: '',
  fall04: '',
  fall05: '',

  bed_sore01: '',
  bed_sore02: '',
  bed_sore03: '',
  bed_sore04: '',
  bed_sore05: '',

  edu01: '',
  edu02: '',

  care_plan01: '',
  care_plan02: '',
  care_plan03: '',

  surgery01: '',
  surgery02: '',
  surgery03: '',

  medicine01: '',
  medicine02: '',

  hospitalization01: '',
  hospitalization02: '',
  hospitalization03: '',
  hospitalization04: '',
  hospitalization05: '',
  hospitalization06: '',
  hospitalization07: '',
  hospitalization08: '',

  ns_fall01: '',
  ns_fall02: '',

  ns_bedsore01: '',

  ns_pt_moving01: '',
  ns_pt_moving02: '',

  ns_edu01: '',

  ns_surgery01: '',

  ns_transfusion01: '',

  ns_infection01: '',

  ns_pain01: '',
  ns_pain02: '',
  ns_pain03: '',

  ns_re_pain01: '',
  ns_re_pain02: '',
  ns_re_pain03: '',
  ns_re_pain04: '',

  ns_pca01: '',
  ns_pca02: '',
  ns_pca03: '',
  ns_pca04: '',

  ns_nausea01: '',
  ns_nausea02: '',

  ns_chemo_side_eff01: '',

  ns_restraint01: '',
  ns_restraint02: '',
  ns_restraint03: '',
  ns_restraint04: '',
  ns_restraint05: '',

  ns_high_risk01: '',
  ns_high_risk02: '',

  right01: '',

  discharge01: '',
  discharge02: '',
  discharge03: '',
  discharge04: '',

  ocs01: '',
};

export const initialNursingProcess = {
  update_at: '',
  nursing_process_narrative_note_survey: [],
};

// 시뮬레이션 기록 - 활동 계획서
export const initialSimulationPlan = {
  update_at: '',
  sp_subject_name: '',
  sp_practice_date: '',
  sp_scenario: '',
  sp_professor: '',
  sp_practice_group: '',
  sp_team_name: '',
  sp_nurse1: '',
  sp_nurse2: '',
  sp_nurse3: '',
  sp_plan: '',
};

// 간호과정 기록지
export const initialProcessRecord = {
  update_at: '',
  pr_subject_name: '',
  pr_practice_date: '',
  pr_scenario: '',
  pr_professor: '',
  pr_practice_group: '',
  pr_team_name: '',
  pr_nurse1: '',
  pr_nurse2: '',
  pr_nurse3: '',
  pr_sign_symptom: '',
  pr_problem: '',
  pr_care: '',
  pr_diagnosis: '',
};

// 개인정보 수집 동의서
export const initialPersonalInfoAgreement = {
  update_at: '',
  pa_agreement: '',
  pa_subject_name: '',
  pa_date: '',
  pa_student_number: '',
  pa_name: '',
  pa_signature: '',
};

// 디브리핑
export const initialDebriefing = {
  update_at: '',
  subject: '',
  date: '',
  class: '',
  team: '',
  student_number: '',
  name: '',
  one: '',
  two: '',
  three: '',
  four: '',
  five: '',
  six: '',
};
